<template>
  <div class="mb-3">
    <v-card dark class="elevation-5" width="250" style="border-radius: 16px">
      <v-list class="py-0" style="background-color: #000">
        <v-list-tile>
          <v-list-tile-title
            style="text-align: center; font-size: 20px; color: white"
            >FOOD DELIVERY</v-list-tile-title
          >
        </v-list-tile>
      </v-list>
      <v-list class="py-0" style="overflow: hidden">
        <v-list-group
          v-for="item in filteredSidebar"
          v-model="item.active"
          :key="item.title"
          :prepend-icon="item.action"
          no-action
        >
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile
            v-for="subItem in item.items"
            :key="subItem.title"
            :to="subItem.url"
          >
            <v-list-tile-content>
              <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-icon>{{ subItem.action }}</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list-group>
        <div v-for="item in filterNogroupItem" :key="item.title">
          <v-list-tile :to="item.url">
            <v-list-tile-action>
              <v-icon>{{ item.action }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </div>
      </v-list>
    </v-card>
    <!-- แถบเมนูแบบเขียนเอง
          <v-flex shrink>
          <v-content>
          <v-layout>
          <v-flex shrink>
          <v-card width="300px" class="elevation-12">
          <v-list dense>
          <v-list-tile v-for="item in items" :key="item.title">
          <v-list-tile-action>
          <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
          </v-list-tile>
          </v-list>
          </v-card>
          </v-flex>
          </v-layout>
          </v-content>
    </v-flex>-->
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      mini: true,
      itemNoGroup: [
        {
          active: true,
          action: "mdi-plus-box",
          permission_name: "food_add_on",
          title: "Add on",
          url:
            "/weserve_admin_login/control/" +
            this.$store.state.backOffice.province +
            "/food/addon-service",
        },
      ],
      items: [
        {
          action: "class",
          title: "Package",
          permission_name: "package_list",
          items: [
            {
              title: "Package list",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/food/packagelist",
            },
          ],
        },
        {
          action: "map",
          title: "Transfer",
          permission_name: "transfer_list",
          items: [
            {
              title: "Transfer rate",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/food/transfer/transferlist",
            },
            {
              title: "Transfer zone",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/food/transfer/transfer_zone",
            },
            {
              title: "Extra time",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/food/transfer/transfer_extra_time",
            },
            {
              title: "Extra store",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/food/transfer/transfer_extra_store",
            },
          ],
        },
        // {
        //   action: "bookmark",
        //   title: "Free delivery",
        //   permission_name: "set_free_price_round",
        //   items: [
        //     {
        //       title: "Set price/round",
        //       url:
        //         "/weserve_admin_login/control/" +
        //         this.$store.state.backOffice.province +
        //         "/food/free/set_price_round",
        //     },
        //   ],
        // },
        {
          action: "bookmark",
          title: "Campaign",
          permission_name: "campaign_distance",
          items: [
            {
              title: "Campaign Distance",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/food/campaigndistance",
            },
          ],
        },
        {
          action: "bookmark",
          title: "Base Distance",
          permission_name: "base_distance",
          items: [
            // {
            //   title: "Set Base Distance",
            //   url:
            //     "/weserve_admin_login/control/" +
            //     this.$store.state.backOffice.province +
            //     "/food/basedistance",
            // },
            {
              title: "Customer Distance",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/food/customer-base-distance",
            },
            {
              title: "Rider Distance",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/food/rider-base-distance",
            },
          ],
        },
        {
          action: "bookmark",
          title: "Price Delivery Food",
          permission_name: "small_order_difference",
          items: [
            {
              title: "Minimum Price Food",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/food/minimum-price-food",
            },
          ],
        },
      ],
    };
  },
  watch: {},
  computed: {
    ...mapState({
      permission: (state) => state.permission,
    }),
    filteredSidebar() {
      return this.items.filter((val) => {
        for (let val2 in this.permission.food) {
          if (val2 == val.permission_name) return val;
        }
      });
    },
    filterNogroupItem() {
      return this.itemNoGroup.filter((val) => {
        for (let val2 in this.permission.food) {
          if (val2 == val.permission_name) return val;
        }
      });
    },
  },
};
</script>
